import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import {
  Button
} from '@material-ui/core';
import {
  Add as AddIcon,
} from '@material-ui/icons';

import FilePickerDialog from './filePickerDialog';
import ImageList from '../itemFamily/imageList';

function getUniqueListBy(arr, key) {
  return [...new Map(arr.map(item => [item[key], item])).values()];
}

const FilePickerMulti = props => {
  const [ open, setOpen ] = useState(false);
  const { t } = useTranslation();

  let {
    fieldName,
    fieldValue = [],
    disabled,
    setFieldValue,
    btnLabel = t('filePicker:addFiles'),
    rootFolderId,
  } = props;

  if(!Array.isArray(fieldValue)) {
    // Nulls are not defaulted in destructuring..
    fieldValue = [];
  }

  const handleOpen = event => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleSelect = newFiles => {
    const newList = getUniqueListBy(fieldValue.concat(newFiles), 'id');
    setFieldValue(newList);
    setOpen(false);
  }

  const handleDelete = fileId => {
    const newArray = fieldValue.filter(file => file.id !== fileId);
    setFieldValue(newArray);
  };

  return (
    <>
      <ImageList images={fieldValue} onDelete={handleDelete} disabled={disabled} />
      <Button variant="outlined" color="primary" startIcon={<AddIcon />} onClick={handleOpen} disabled={disabled}>{btnLabel}</Button>
      <FilePickerDialog multiselect open={open} title={fieldName} handleSelect={handleSelect} handleClose={handleClose} rootFolderId={rootFolderId} selectedFiles={props.fieldValue} />
    </>
  )
};

FilePickerMulti.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.array,
  setFieldValue: PropTypes.func,
  btnLabel: PropTypes.string,
  disabled: PropTypes.bool,
  rootFolderId: PropTypes.string,
}

export default FilePickerMulti;
